import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularhhwAPI = createAsyncThunk(
  "auth/hhw/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.holidayHomeWorkAction(`${id}`, 1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailshhwSlice = createSlice({
  name: "get particular hhw",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularhhw: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularhhwAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularhhwAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularhhwAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularhhw } = getparticularDetailshhwSlice.actions;
export const getparticularDetailshhwReducer =
  getparticularDetailshhwSlice.reducer;
